import { ListPage as ListPageComponent } from './ListPage';
import { QUERY, withContainer } from './withContainer';

const ListPage = withContainer(ListPageComponent);

export {
  ListPage,
  ListPageComponent,
  QUERY,
};
export * from './withContainer';
